"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._JSONInput = {
    type: "structure",
    required: [],
    members: {
        Type: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_JSONInput.js.map